import { render, staticRenderFns } from "./TeacherSubjectClassCursus.vue?vue&type=template&id=a1d70172"
import script from "./TeacherSubjectClassCursus.vue?vue&type=script&lang=js"
export * from "./TeacherSubjectClassCursus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports